module.exports = __webpack_public_path__ + "FixelText-MediumItalic.6d05d782e145d4c0344e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelText/FixelText-MediumItalic.woff2
// module id = ./src/assets/webfonts/fixelText/FixelText-MediumItalic.woff2
// module chunks = styles